import { render, staticRenderFns } from "./CoursesWorld.vue?vue&type=template&id=b0882618&scoped=true&"
import script from "./CoursesWorld.vue?vue&type=script&lang=js&"
export * from "./CoursesWorld.vue?vue&type=script&lang=js&"
import style0 from "./CoursesWorld.vue?vue&type=style&index=0&id=b0882618&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0882618",
  null
  
)

export default component.exports